


































































































import { Component, Vue, Watch } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
import UserResearchCenter from '@/models/security/userResearchCenter.Model';
import UserResearchCenterService from '@/services/UserResearchCenter.service';
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue"
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue"
import User from '../../models/security/user.model';
import BaseSelectPerson from '@/components/base/baseSelectPerson/baseSelectPerson.vue';
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";

@Component({
  components: {
    UserBasicInformationComponent, ResearchCenterBasicInformationComponent,BaseSelectResearchCenter,BaseSelectPerson
  }
})
export default class ResearchCenterCollaboratorTable extends GenericBTable<UserResearchCenter> {
  isLoading = false;
  userResearchCenter = new UserResearchCenterService();
  name = "";
  researchCenterId = null;
  userId =null;
  created() {
    //this.permissionValue = PermissionValue.CENTROINVESTIGACIONES;
    this.tableConfig.controller = "UserResearchCenter/GetUserResearchCenterColaboratorsByAdmin";
    this.formatColumns();
  }

  formatColumns() {
    let user = new BTableColumn("user", "table.userDescription", true);
    let researchCenter = new BTableColumn("researchCenter", "table.researchCenterDescription", true);
    user.customTemplate = true;
    researchCenter.customTemplate = true;

    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.insertColumns(user, researchCenter);
    this.tableConfig.actions.customTemplate = true;
  }
  @Watch("researchCenterId")
  getResultResearch(){
    this.tableConfig.whereParams = `researchCenterId eq ${this.researchCenterId}`;
    this.tableConfig.reload();
  }
  
  @Watch("userId")
  getResultUser(){
    this.tableConfig.whereParams = `userId eq ${this.userId}`;
    this.tableConfig.reload();
  }
}
